import { http } from './config'

export default {
    listarServicos: () => {
        return http.get(`/v1/produtos?tipo=SERVIÇO`)
    },
    listar: (data) => {
        const queryParams = `estoque_id=${data.estoque_id ? + data.estoque_id : 1}
        &habilitado=${data.desabilitado ? false : true}
        ${data.id ? '&id='+data.id : ''}
        ${data.descricao ? '&descricao='+data.descricao : ''}
        ${data.codigo_barra ? '&codigo_barra='+data.codigo_barra : ''}
        ${data.marca ? '&marca='+data.marca : ''}
        ${data.secao_id ? '&produtoId='+data.secao_id : ''}
        ${data.grupo_id ? '&grupoId='+data.grupo_id : ''}
        ${data.tipo ? '&tipo='+data.tipo : ''}`

        
        if(!data.limite){
            return http.get(`/v1/produtos?${queryParams}`)
        }else{
            return http.get(`/v1/produtos?${queryParams}&limit=${data.limite}&page=${data.pagina}`)
        }
    },
    // listar: (data) => {
    //     if(!data.query){
    //         return http.get(`/v1/produtos?limit=${data.limite}&page=${data.pagina}`)
    //     }else{
    //         return http.get(`/v1/produtos?limit=${data.limite}&page=${data.pagina}&campo=${data.query.campo}&valor=${data.query.valor}`)
    //     }
    // },
    salvar: (produto) => {
        return http.post('/v1/produtos', produto)
    },
    editar: (id) => {
        if(id || id != undefined || id != null){
            return http.get(`/v1/produtos/${id}`)
        }
    },
    atualizar: (produto) => {
        return http.put(`/v1/produtos/${produto.id}`, produto)
    },
    excluir: (id) => {
        return http.delete(`/v1/produtos/${id}`)
    },
    pesquisar: (data) => {
        return http.get(`v1/produto/pesquisar?campo=${data.campo}&valor=${data.valor}`)
    },
    porCodigoDeBarras: (codigoBarras) => {
        if(codigoBarras || codigoBarras != undefined || codigoBarras != null){
            return http.get(`/v1/produto/${codigoBarras}/codigo-barra`)
        }
    },
    visualizarPagina: (data) => {
        if(!data.query.campo && !data.query.valor){
            return http.get(`${data.path}?limit=${data.limite}&page=${data.pagina}`)
        }else{
            return http.get(`${data.path}?limit=${data.limite}&page=${data.pagina}&campo=${data.query.campo}&valor=${data.query.valor}`)
        }
    },
    salvarFoto: (data, id) => {
        return http.post(`/v1/produto/${id}/foto/salvar`, data)
    },
    clonar: (produtoId) => {
        return http.get(`/v1/produto/${produtoId}/clonar`);
    }
}